import { lazy } from "react";
import { buildRouteItem } from "router/routesUtils";
import {
  TITLE_IDENTIFICATION,
  PATH_IDENTIFICATION,
  KEY_IDENTIFICATION,
  /* TITLE_CAMPAGNE_IDENTIFICATION,
  PATH_CAMPAGNE_IDENTIFICATION,
  KEY_CAMPAGNE_IDENTIFICATION, */
  TITLE_IDENTIFICATION_ANIMAL,
  PATH_IDENTIFICATION_ANIMAL,
  KEY_IDENTIFICATION_ANIMAL,
  TITLE_IDENTIFICATION_DASHBOARD,
  PATH_IDENTIFICATION_DASHBOARD,
  KEY_IDENTIFICATION_DASHBOARD,
} from "layouts/identification/constant/path";

// const Identification = lazy(() => import("layouts/identification"));
// const Campagne = lazy(() => import("layouts/identification/rubrique/campagneIdentification"));
const Animaux = lazy(() => import("layouts/identification/rubrique/animaux"));
const Dashboard = lazy(() => import("layouts/identification/rubrique/dashboard"));

/* const ROUTES_IDENTIFICATION = [
  {
    type: "collapse",
    name: <span style={{ color: "black" }}>{TITLE_IDENTIFICATION}</span>,
    key: KEY_IDENTIFICATION,
    icon: (
      <Icon fontSize="small" style={{ color: "black" }}>
        source
      </Icon>
    ),
    route: PATH_IDENTIFICATION,
    role: [
      SUPER_ADMIN_ROLE,
      SUPERVISEUR_ROLE,
      ADMIN_PAYS_ROLE,
      ADMIN_DIRECTION_ROLE,
      ADMIN_SOUS_SECTEUR_ROLE,
      ADMIN_REGION_ROLE,
      ADMIN_DEPARTEMENTAL_ROLE,
      RESPONSABLE_FERME,
    ],
    collapse: [
      {
        name: <span style={{ color: "black" }}>{TITLE_IDENTIFICATION}</span>,
        key: KEY_IDENTIFICATION,
        route: PATH_IDENTIFICATION,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Dashboard />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{TITLE_IDENTIFICATION_DASHBOARD}</span>,
        key: KEY_IDENTIFICATION_DASHBOARD,
        route: PATH_IDENTIFICATION_DASHBOARD,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Dashboard />
          </Suspense>
        ),
        collapse: [],
      },
      {
        name: <span style={{ color: "black" }}>{TITLE_IDENTIFICATION_ANIMAL}</span>,
        key: KEY_IDENTIFICATION_ANIMAL,
        route: PATH_IDENTIFICATION_ANIMAL,
        component: (
          <Suspense fallback={<SuspenceComponent />}>
            <Animaux />
          </Suspense>
        ),
        collapse: [],
      },
    ],
  },
];
export default ROUTES_IDENTIFICATION; */

const REPRODUCTION_MENU_ITEMS = [
  {
    title: TITLE_IDENTIFICATION,
    key: KEY_IDENTIFICATION,
    path: PATH_IDENTIFICATION,
    component: Dashboard,
  },
  {
    title: TITLE_IDENTIFICATION_DASHBOARD,
    key: PATH_IDENTIFICATION_DASHBOARD,
    path: KEY_IDENTIFICATION_DASHBOARD,
    component: Dashboard,
  },
  {
    title: TITLE_IDENTIFICATION_ANIMAL,
    key: KEY_IDENTIFICATION_ANIMAL,
    path: PATH_IDENTIFICATION_ANIMAL,
    component: Animaux,
  },
];

const ROUTES_REPRODUCTION = [
  buildRouteItem(
    TITLE_IDENTIFICATION,
    KEY_IDENTIFICATION,
    PATH_IDENTIFICATION,
    REPRODUCTION_MENU_ITEMS,
    // "folderCopyIcon"
    "pets"
  ),
];
export default ROUTES_REPRODUCTION;
